// ---------------------------------------------------------------------------
// PWA_ControlBillet — Reusable toggle switch
// Styled toggle with smooth transition, accent color when on, gray when off.
// ---------------------------------------------------------------------------

interface Props {
  enabled: boolean;
  onChange: (value: boolean) => void;
  label: string;
}

export function Toggle({ enabled, onChange, label }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={() => onChange(!enabled)}
      className="flex items-center justify-between w-full min-h-[44px] py-2 gap-4 group"
    >
      <span className="text-sm text-white font-medium">{label}</span>
      <div
        className={`relative inline-flex h-7 w-12 shrink-0 rounded-full transition-colors duration-200 ease-in-out ${
          enabled ? 'bg-accent' : 'bg-gray-600'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 mt-1 rounded-full bg-white shadow-md transform transition-transform duration-200 ease-in-out ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </div>
    </button>
  );
}
